var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendericon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_979_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.45312 6.28906H7.54688V7.38281H6.45312V6.28906Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3594 1.09375H11.7031V0H10.6094V1.09375H3.39062V0H2.29688V1.09375H1.64062C0.735984 1.09375 0 1.82973 0 2.73438V12.3594C0 13.264 0.735984 14 1.64062 14H7.26693C6.88807 13.6872 6.55922 13.3184 6.29177 12.9062H1.64062C1.33908 12.9062 1.09375 12.6609 1.09375 12.3594V5.14062H12.9062V6.29177C13.3184 6.55923 13.6872 6.88808 14 7.26693V2.73438C14 1.82973 13.264 1.09375 12.3594 1.09375ZM12.9062 4.04688H1.09375V2.73438C1.09375 2.43283 1.33908 2.1875 1.64062 2.1875H2.29688V3.28125H3.39062V2.1875H10.6094V3.28125H11.7031V2.1875H12.3594C12.6609 2.1875 12.9062 2.43283 12.9062 2.73438V4.04688Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3086 6.61719C8.27315 6.61719 6.61719 8.27315 6.61719 10.3086C6.61719 12.344 8.27315 14 10.3086 14C12.344 14 14 12.344 14 10.3086C14 8.27315 12.344 6.61719 10.3086 6.61719ZM10.3086 12.9062C8.87625 12.9062 7.71094 11.7409 7.71094 10.3086C7.71094 8.87625 8.87625 7.71094 10.3086 7.71094C11.7409 7.71094 12.9062 8.87625 12.9062 10.3086C12.9062 11.7409 11.7409 12.9062 10.3086 12.9062Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8281 8.47656H9.73438V10.8555H11.7578V9.76172H10.8281V8.47656ZM4.26562 8.47656H5.35938V9.57031H4.26562V8.47656ZM2.07812 8.47656H3.17188V9.57031H2.07812V8.47656ZM2.07812 6.28906H3.17188V7.38281H2.07812V6.28906ZM2.07812 10.6641H3.17188V11.7578H2.07812V10.6641ZM4.26562 6.28906H5.35938V7.38281H4.26562V6.28906ZM4.26562 10.6641H5.35938V11.7578H4.26562V10.6641Z",
    fill: "#004276"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_979_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendericon2);
export default __webpack_public_path__ + "static/media/calendericon2.8f4a03fde7c379b8a31e654e48b0de2c.svg";
export { ForwardRef as ReactComponent };